import { printLabel, printLabelMixed } from '@/helpers/printLabel';
import shippingLabelConstants from '@/store/modules/shippingLabelPage/constants';
import addressConstants from '@/store/modules/address/constants';
import PurchaseOrderService from '@/services/purchaseOrderService';
import PrintLabelService from '@/services/PrintLabelService';
import router from '@/router';

const printLabelService = new PrintLabelService();
const purchaseOrderService = new PurchaseOrderService();

export default {
  async [shippingLabelConstants.actionTypes.loadShippingInfo]({ commit }, purchaseOrderNumber) {
    const shippingInfo = await purchaseOrderService.getPurchaseOrderShippingInfo(purchaseOrderNumber);

    commit(`shipTo/${addressConstants.mutationTypes.load}`, shippingInfo.shipTo);
    commit(`shipFrom/${addressConstants.mutationTypes.load}`, shippingInfo.shipFrom);
    commit(shippingLabelConstants.mutationTypes.shippingInfoWasLoaded);
  },
  async [shippingLabelConstants.actionTypes.printLabel]({ getters }) {
    const route = router.history.current;

    const shippingInfo = getters[shippingLabelConstants.getterTypes.shippingInfo](true);

    const queryData = await printLabelService.addPrintLabel(JSON.stringify(shippingInfo));

    printLabel(router, route.params.purchaseOrderNumber, route.params.sku, queryData);
  },
  async [shippingLabelConstants.actionTypes.printLabelMixed]({ getters }) {
    const route = router.history.current;

    const shippingInfo = getters[shippingLabelConstants.getterTypes.shippingInfo]();

    const queryData = await printLabelService.addPrintLabel(JSON.stringify(shippingInfo));

    printLabelMixed(router, route.params.purchaseOrderNumber, route.params.sku, queryData);
  },
};
